// extracted by mini-css-extract-plugin
export default {"wrapper":"xha-z","play":"yha-z"};